module.exports = __webpack_public_path__ + "img/藍泡泡球_0044.1b4ba57d.png";